import React from 'react';
import { registerWidget } from '@okapi/core';
import {
  ProjectConfiguration,
  ProjectConfigurationProps,
  ProjectConfigurationState,
} from 'entries/common/widgets';
import { createApi } from 'utils/api';

registerWidget<ProjectConfigurationProps, ProjectConfigurationState>(
  `${__NAME__}/projectConfiguration`,
  state => props => {
    const host = state.env.ORCHESTRATOR_HOST;
    const apiKey = state.env.API_KEY;
    const api = createApi(host, apiKey);
    return <ProjectConfiguration {...state} {...props} api={api} />;
  }
);
